import { useState, useCallback, useEffect } from 'react';

export function useVideoFile() {
  const [videoFile, setVideoFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [fileError, setFileError] = useState(null);

  const loadFile = useCallback((file) => {
    setFileError(null);
    if (!file) return;

    if (!file.type.startsWith('video/')) {
      setFileError('동영상 파일(.mp4, .mov, .webm 등)만 업로드할 수 있습니다.');
      return;
    }

    if (videoUrl) {
      URL.revokeObjectURL(videoUrl);
    }

    const url = URL.createObjectURL(file);
    setVideoFile(file);
    setVideoUrl(url);
    setIsPlaying(false);
  }, [videoUrl]);

  const clearVideo = useCallback(() => {
    if (videoUrl) {
      URL.revokeObjectURL(videoUrl);
    }
    setVideoFile(null);
    setVideoUrl(null);
    setIsPlaying(false);
    setFileError(null);
  }, [videoUrl]);

  useEffect(() => {
    return () => {
      if (videoUrl) {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, [videoUrl]);

  return {
    videoFile,
    videoUrl,
    isPlaying,
    setIsPlaying,
    fileError,
    loadFile,
    clearVideo,
  };
}
